"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringBuilder = void 0;
var StringBuilder = /** @class */ (function () {
    function StringBuilder(s) {
        if (s === void 0) { s = ''; }
        this.s = s;
        this.strs = new Array();
        this.dirty = false;
        if (s)
            this.strs.push(s);
    }
    StringBuilder.prototype.append = function (s) {
        if (s) {
            this.strs.push(s);
            this.dirty = true;
        }
        return this;
    };
    StringBuilder.prototype.toString = function () {
        if (this.dirty) {
            this.s = this.strs.join('');
            this.dirty = false;
        }
        return this.s;
    };
    return StringBuilder;
}());
exports.StringBuilder = StringBuilder;
//# sourceMappingURL=StringBuilder.js.map